import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELSEATCOUNTITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelSeatCountItemBlockDescriptor: _generatedCartFunnelSeatCountItemBlockDescriptor,
  cartFunnelSeatCountItemBlockBlocDefinition,
  cartFunnelSeatCountItemBlockDashboardLayout,
  cartFunnelSeatCountItemBlockConfig,
  cartFunnelSeatCountItemBlockResolveConfig,
  cartFunnelSeatCountItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Seat count",
    componentType: 'CartFunnelSeatCountItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / Seat count.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
      { bloc: "KioskCartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'translation',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-seat-count-item.title.label",
      }
    }),
    placeholder: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-seat-count-item.placeholder.label",
      }
    })
  }),

  () => ({
    omitFields: ["placeholder"] as const,
    tabs: [
      {
        label: "pages.blocks.cart-funnel-seat-count-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-seat-count-item.fieldset.field.label",
            fields: ["title"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelSeatCountItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelSeatCountItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelSeatCountItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelSeatCountItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelSeatCountItemBlockDescriptor, cartFunnelSeatCountItemBlockProperties, fieldOrder);
}

export {
  cartFunnelSeatCountItemBlockBlocDefinition,
  cartFunnelSeatCountItemBlockDashboardLayout,
  cartFunnelSeatCountItemBlockProperties,
  cartFunnelSeatCountItemBlockConfig,
  cartFunnelSeatCountItemBlockResolveConfig,
};

export type CartFunnelSeatCountItemBlockConfig = typeof cartFunnelSeatCountItemBlockConfig;
